export type ProgressReporter = ((description: string) => void) & {
  done: () => void;
};

// `brobs.track` and the overlay live in the parent window
// (`index.html` loads brobs-progress.js). The gaze iframe emits
// "progress" on the parent's brobs instance.
export function trackProgress(system: string): ProgressReporter {
  const brobs = (window as any).brobs;

  const emit = (event: Record<string, unknown>) => {
    try {
      brobs?.emit("progress", event);
    } catch {
      /* ignore */
    }
  };

  emit({ action: "start", system, ts: Date.now() });

  const report = ((description: string) => {
    emit({ action: "step", system, description, ts: Date.now() });
  }) as ProgressReporter;

  report.done = () => {
    emit({ action: "done", system, ts: Date.now() });
  };

  return report;
}
